module.exports = __webpack_public_path__ + "img/single.aa49d4a0.png";